'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routes from './mobile.routes';

export class MobileComponent {
  /*@ngInject*/
  constructor() {
  }
}

export default angular.module('storageApp.mobile', [uiRouter])
  .config(routes)
  .component('mobile', {
    template: require('./mobile.html'),
    controller: MobileComponent,
    controllerAs: 'mobileCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/mobile/mobile.component.js